import React from 'react';
import './experience.css'

function Experience() {
    return(
        <div>
            <section id='experience' className='alternate_bg'>
            <h5>Worked With</h5>
            <h2>Experience</h2>

            {/* ---- FIRST_EXPERIENCE ---- */}
            <div className='experience__container'>
                    <h5 className='experience__date left'>Feb 2018 - March 2018</h5>  
                    <div className='experience__description left'>
                        <h3>IT Assistant</h3>
                        <h4>Microlise</h4>
                        <ul>
                            <li>Creates a workout and nutrition schedule based on your physiology and personal targets.</li>
                            <li>In the development process, I learned how to link the frontend to backend via API calls.</li>
                        </ul>
                    </div>
            </div>

            {/* ---- SECOND_EXPERIENCE ---- */}
            <div className='experience__container right'>
                    <div className='experience__description right'>
                        <h3>Video Producer</h3>
                        <h4>Nottinghamshire Police</h4>
                        <ul>
                            <li>Filming and editing community events hosted by the police.</li>
                            <li>Most recently produced Black History Month documentary in collaboration with Trent Bridge and Nottingham City Council.</li>
                        </ul>
                    </div>
                    <h5 className='experience__date right'>July 2022 - Oct 2022</h5>  
            </div>

            {/* ---- THIRD_EXPERIENCE ---- */}
            <div className='experience__container'>
                    <h5 className='experience__date'>Feb 2021 - Present</h5>  
                    <div className='experience__description'>
                        <h3>Video Editor</h3>
                        <h4>AJ Sport Academy</h4>
                        <ul>
                            <li>Managed the orginisations media accounts including TikTok and YouTube.</li>
                            <li>Nature of the taught/required me to communicate with the customer directly.</li>
                        </ul>
                    </div>
            </div>
            </section>
        </div>
    )
}

export default Experience;